<template>
  <div>
    <PageHeader :title="isEditMode ? 'แก้ไขหนังสือ' : 'เพิ่มหนังสือ'"></PageHeader>
    <b-container>
      <b-row>
        <b-col>
          <div class="py-4">
            <div class="bg-container">
              <b-row>
                <b-col cols="12" md="7">
                  <b-form-group label="รหัสหนังสือ" label-class="font-weight-bold">
                    <b-form-input
                      v-model="form.book_code"
                      placeholder="กรอกรหัสหนังสือ"
                      :state="bookCodeValidation.isValid === null ? null : bookCodeValidation.isValid"
                      @blur="handleValidateBookCode"
                    ></b-form-input>
                    <b-form-valid-feedback v-if="bookCodeValidation.isValid === true">
                      รหัสหนังสือสามารถใช้ได้
                    </b-form-valid-feedback>
                    <b-form-invalid-feedback v-if="bookCodeValidation.isValid === false">
                      รหัสหนังสือนี้ถูกใช้แล้ว กรุณาใช้รหัสอื่น
                    </b-form-invalid-feedback>
                    <small v-if="bookCodeValidation.checking" class="text-muted">
                      กำลังตรวจสอบรหัสหนังสือ...
                    </small>
                  </b-form-group>

                  <b-form-group label="ชื่อหนังสือ" label-class="font-weight-bold">
                    <b-form-input
                      v-model="form.book_name"
                      placeholder="กรอกชื่อหนังสือ"
                    ></b-form-input>
                  </b-form-group>

                  <b-form-group label="หมายเหตุ" label-class="font-weight-bold">
                    <b-form-textarea
                      v-model="form.book_remark"
                      rows="4"
                    ></b-form-textarea>
                  </b-form-group>
                </b-col>

                <b-col cols="12" md="5">
                  <b-form-group label="ปกหนังสือ" label-class="font-weight-bold">
                    <div class="d-flex align-items-center mb-3">
                      <b-form-file
                        v-model="coverFile"
                        accept=".jpg,.jpeg,.png,.gif,image/jpeg,image/png,image/gif"
                        placeholder="ยังไม่ได้เลือกไฟล์ใด"
                        browse-text="เลือกไฟล์"
                        @input="onCoverFileChange"
                      ></b-form-file>
                    </div>
                    <div v-if="coverPreview" class="mt-2">
                      <b-img
                        :src="coverPreview"
                        fluid
                        rounded
                        alt="ปกหนังสือ"
                        style="max-height: 400px"
                      ></b-img>
                    </div>
                  </b-form-group>
                </b-col>
              </b-row>

              <div class="d-flex justify-content-end mt-4">
                <b-button variant="light" class="mr-2" @click="goBack">
                  ยกเลิก
                </b-button>
                <b-button
                  variant="primary"
                  :disabled="isLoading || !isFormValid"
                  @click="submitForm"
                >
                  บันทึก
                </b-button>
              </div>
            </div>
          </div>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import PageHeader from "../../layouts/PageHeader";
import { mapActions, mapGetters } from "vuex";

export default {
  name: "BookFormPage",
  components: {
    PageHeader,
  },
  props: {
    company: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      form: {
        book_code: "",
        book_name: "",
        book_remark: "",
        coverImage: null,
      },
      coverFile: null,
      coverPreview: null,
      originalCoverImage: null,
      imageChanged: false,
      bookCodeValidation: {
        isValid: null,
        message: '',
        checking: false
      },
      initirizing: false
    };
  },
  computed: {
    ...mapGetters("BookManagement", ["isLoading", "bookInfo"]),
    isEditMode() {
      return !!this.$route.params.bookId;
    },
    isFormValid() {
      return this.form.book_code && this.form.book_name && this.bookCodeValidation.isValid !== false;
    },
  },
  async mounted() {
    this.initirizing = true;
    if (this.isEditMode) {
      await this.fetchBookInfo(this.$route.params.bookId);
      if (this.bookInfo) {
        this.form.book_code = this.bookInfo.book_code;
        this.form.book_name = this.bookInfo.book_name;
        this.form.book_remark = this.bookInfo.book_remark || "";
        this.form.coverImage = this.bookInfo.image_url;
        this.coverPreview = this.bookInfo.image_url;
        this.originalCoverImage = this.bookInfo.image_url;
        this.imageChanged = false;
      }
    }
    this.initirizing = false;
  },
    methods: {
    ...mapActions("BookManagement", [
      "fetchBookInfo",
      "createBook",
      "updateBook",
      "validateBookCode",
    ]),
    onCoverFileChange(file) {
      if (file) {
        const allowedTypes = ["image/jpeg", "image/png", "image/gif"];
        const allowedExtensions = ["jpg", "jpeg", "png", "gif"];
        const fileExtension = (file.name || "").split(".").pop().toLowerCase();

        if (!allowedTypes.includes(file.type) || !allowedExtensions.includes(fileExtension)) {
          this.coverFile = null;
          this.form.coverImage = null;
          this.coverPreview = this.isEditMode && this.bookInfo ? this.bookInfo.image_url : null;
          this.imageChanged = false;
          this.$bvToast.toast('รองรับเฉพาะไฟล์รูปภาพนามสกุล .jpg, .jpeg, .png, .gif เท่านั้น', {
            title: 'Error',
            variant: 'danger',
            toaster: 'b-toaster-top-right',
            autoHideDelay: 3000,
            appendToast: true,
            noHoverPause: true,
            noCloseButton: true
          });
          return;
        }

        this.form.coverImage = file;

        // Create preview for display
        const reader = new FileReader();
        reader.onload = (e) => {
          this.coverPreview = e.target.result;
        };
        reader.readAsDataURL(file);

        this.imageChanged = true;
      } else {
        this.coverPreview = this.isEditMode && this.bookInfo ? this.bookInfo.image_url : null;
        this.form.coverImage = null;
        this.imageChanged = true;
      }
    },
    async submitForm() {
      try {
        const formData = {
          companyId: localStorage.getItem("ComId"),
          book_code: this.form.book_code,
          book_name: this.form.book_name,
          book_remark: this.form.book_remark,
        };
        
        if (this.form.coverImage instanceof File || (this.isEditMode && this.imageChanged)) {
          formData.coverImage = this.form.coverImage;
        }
        
        if (this.isEditMode) {
          await this.updateBook({
            id: this.$route.params.bookId,
            ...formData,
          });
          this.$bvToast.toast('อัปเดตหนังสือสำเร็จ', {
            title: 'Success',
            variant: 'success',
            toaster: 'b-toaster-top-right',
            autoHideDelay: 2000,
            appendToast: true,
            noHoverPause: true,
            noCloseButton: true
          });
        } else {
          await this.createBook(formData);
          this.$bvToast.toast('สร้างหนังสือสำเร็จ', {
            title: 'Success',
            variant: 'success',
            toaster: 'b-toaster-top-right',
            autoHideDelay: 2000,
            appendToast: true,
            noHoverPause: true,
            noCloseButton: true
          });
        }
        this.goBack();
      } catch (error) {
        console.error('Submit form error:', error);
        this.$bvToast.toast('เกิดข้อผิดพลาด กรุณาลองใหม่อีกครั้ง', {
          title: 'Error',
          variant: 'danger',
          toaster: 'b-toaster-top-right',
          autoHideDelay: 3000,
          appendToast: true,
          noHoverPause: true,
          noCloseButton: true
        });
      }
    },
    goBack() {
      this.$router.push({
        name: "book.management.index",
      });
    },
    async handleValidateBookCode() {
      if (this.initirizing) {
        return;
      }
      const bookCode = this.form.book_code;
      
      this.bookCodeValidation.isValid = null;
      
      if (!bookCode) {
        return;
      }
      
      if (this.isEditMode && bookCode === this.bookInfo?.book_code) {
        this.bookCodeValidation.isValid = true;
        return;
      }
      
      this.bookCodeValidation.checking = true;
      
      try {
        const payload = {
          bookCode: bookCode
        };
        
        if (this.isEditMode && this.bookInfo?.book_id) {
          payload.bookId = this.bookInfo.book_id;
        }
        
        const result = await this.validateBookCode(payload);
        
        this.bookCodeValidation.isValid = result.valid;
        
      } catch (error) {
        this.bookCodeValidation.isValid = null;
      } finally {
        this.bookCodeValidation.checking = false;
      }
    },
  },
};
</script>
